import { mdToHtml, sanitizeHtml } from "@/lib/markdown";

/** Formatted text as it was written — markdown by default, stored HTML for hearing logs. */
export const Markdown = ({ text, mode = "markdown", className = "", testId, inline = false }) => {
  if (!(text || "").trim()) return null;
  const html = mode === "html" ? sanitizeHtml(text) : mdToHtml(text);
  const Tag = inline ? "span" : "div";
  return (
    <Tag
      data-testid={testId}
      className={`rich-text ${inline ? "rich-text-inline" : ""} ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
